import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import auth from './auth'
import dashboard from './dashboard.module'
import shipping from './shipping.module'
import paymentMethod from './paymentMethod.module'
import address from './address.module'
import user from './user.module'
import faqs from './faqs.module'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    dashboard,
    shipping,
    paymentMethod,
    user,
    address,
    faqs
  }
})

export default store
